/** @format */

import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { Chain } from '@shared/data-access/interfaces';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { MediaModule } from '@shared/media/components';
import { NgClass } from '@angular/common';

@Component({
	selector: 'plp-components-pinned-content',
	imports: [NgClass, HmfButtonComponent, MediaModule],
	templateUrl: './pinned-content.component.html',
	styleUrl: './pinned-content.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PinnedContentComponent {
	@Input() availabilityOnProductCardsEnabled = true;
	@Input() column = 0;
	@Input() dataEm = '';
	imagePagePosition = input(0);
	lazyLoad = input(false);
	@Input() pinnedContent;
	@Input() row = 0;
	showCustomerRating = input(false);

	isPublicLands = false;
	replace = /[^0-9a-zA-Z]/g;

	constructor(private readonly chain: Chain) {
		this.isPublicLands = this.chain.chainIdentifierAbbr === 'pl';
	}

	goToPinnedContentUrl(link: string): void {
		window.location.href = link;
	}
}
